export default "__VITE_ASSET__BbyN2w5C__"